import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ODataModel } from '../../interfaces/odata-model.interface';
import { TreeViewNode } from '../../models/primitive/tree-view-node';
import { TreeViewModel } from '../../models/primitive/tree-view.model';

@Component({
    selector: 'pace-core-tree',
    templateUrl: './tree.component.html',
    styleUrl: './tree.component.scss',
})
export class TreeComponent implements OnInit {
    @Input() public model: TreeViewModel<ODataModel>;
    @Input() public parentForm: FormGroup;
    @Output() public nodeSelected: EventEmitter<TreeViewNode<ODataModel>> = new EventEmitter<
        TreeViewNode<ODataModel>
    >();

    protected readonly faCheck = faCheck;
    public tree: TreeViewNode<ODataModel>;

    public ngOnInit(): void {
        this.tree = this.model?.value;
    }
    public clickNode(node: TreeViewNode<ODataModel>): void {
        this.nodeSelected.emit(node);
    }

    public collapseAll(): void {
        const firstLevelNodes = this.model.value.children;
        firstLevelNodes.forEach((node) => {
            node.collapse();
        });
    }
}
